import { createFileRoute } from '@tanstack/react-router';

import { RoleDetailPage } from '@/features/members/pages/RoleDetailPage';

export const Route = createFileRoute('/_authenticated/roles/$roleId')({
  component: RoleDetailPage,
});
